import defaultBg from '~/assets/images/chat/chat-bg-default.png';

export const DEFAULT_CHAT_COLOR_1 = '#E20074';

export const DEFAULT_CHAT_COLOR_2 = '#A49DF1';

export const DEFAULT_CHAT_BG = defaultBg;
